import React from 'react'
import Meta from '../modules/meta'
import './contact.scss'

const metadata = {
  title:
    'Contacts | Psychologue Montpellier au quartier des arceaux | Morgane Laroche',
  description:
    'Adresse du cabinet. Coordonnées. Plan d’accès. Lien du site. Matricules. Mon cabinet situé au 300 rue Auguste Broussonnet, quartier des arceaux, à deux pas du tram Place Albert 1er Saint Charles.',
}

const Contact = () => (
  <div className="container container--page">
    <Meta title={metadata.title} description={metadata.description} />
    <div className="container__block">
      <h1 className="container__block-title">CONTACTS</h1>
      <div className="container__block-contact">
        <div className="contact-item__map">
          <iframe
            title="Cabinet psychologue à Montpellier"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11554.321951296171!2d3.8701237!3d43.6152757!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x8f38e3a6b95f3e0e!2sMorgane%20Laroche!5e0!3m2!1sfr!2sfr!4v1605720945679!5m2!1sfr!2sfr"
            allowFullScreen
          />
        </div>
        <div className="contact-item">
          <ul
            className="contact-item__list"
            itemProp="address"
            itemScope
            itemType="http://schema.org/PostalAddress"
          >
            <li>300 Rue Auguste Broussonnet</li>
            <li>34090 Montpellier</li>
            <li>Arrêt de tram Place Albert 1er – Saint Charles</li>
            <li>
              <a
                className="container__block-link"
                target="_blank"
                href="https://tam.cartographie.pro/"
              >
                Plan d’accès{' '}
              </a>
            </li>
          </ul>

          <ul className="contact-item__list">
            <li>
              <a
                className="container__block-link"
                href="tel:+33674318234"
                itemProp="telephone"
              >
                <span>Tél:</span> 06.74.31.82.34{' '}
              </a>
            </li>
            <li>
              <a
                className="container__block-link container__block-link--ellipsis"
                href="mailto:psychologue.morgane.laroche@gmail.com"
                itemProp="email"
              >
                <span>E-mail:</span> psychologue.morgane.laroche@gmail.com
              </a>
            </li>
          </ul>

          <ul className="contact-item__list">
            <li>Numéro ADELI : 34 93 2875 7</li>
            <li>Numéro Siret : 833 159 585 00045</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contacts.js